import axios from 'axios'
import QueryParamsUtil from 'api/utils/query-params-util'

const API_PATH = 'admins/announcements/templates'

const NotificationTemplatesApi = {
  /**
   * Get list of notification templates
   * Invoke `GET admins/announcements/templates
   * @param {object} tableState - ReactTable final state
   * @param {object} additionalFilters - A plain object to get customize filters outside `tableState`
   */
  get: async ({
    page = 1,
    perPage = 10,
    name = '',
    text = '',
    channel = '',
    provider = '',
    scheduled_date = '',
    sort_by = 'created_at',
    sort_order = 'desc'
  }) => {
    const request  = {
      page           : page,
      per_page       : perPage,
      name           : name,
      text           : text,
      channel        : channel,
      scheduled_date : scheduled_date,
      provider       : provider,
      sort_by        : sort_by,
      sort_order     : sort_order
    }
    const params   = QueryParamsUtil.format(null, request)
    const response = await axios.get(API_PATH, { params })
    return response
  },
  /**
   * Get detail of a notification templates
   * Invoke `GET admins/announcements/templates/:id
   * @param {string} id - template id
   */
  show: async (id) => {
    const path     = `${API_PATH}/${id}`
    const response = await axios.get(path)
    return response
  },
  /**
   * Create notification template
   * Invoke `POST admins/announcements/templates/
   * @param {object} payload - Payload data to be send to backend
   */
  create: async ({ template }) => {
    const response = await axios.post(API_PATH, template)
    return response
  },
  /**
   * Update notification template
   * Invoke `PATCH admins/announcements/templates/:id
   * @param {string} id - template id
   * @param {object} payload - Payload data to be send to backend
   */
  update: async ({ template }) => {
    const path     = `${API_PATH}/${template.id}`
    const response = await axios.patch(path, template)
    return response
  },
  /**
   * Get sample of users/customers/sellers that will become our notification receivers
   * Invoke `POST admins/announcements/templates/show_csv_data
   * @param {object} payload - Payload data to be send to backend
   */
  showCsvData: async ({ showReceiverRequest }) => {
    const path            = `${API_PATH}/show_csv_data`
    const receiverPayload = new FormData()
    Object.keys(showReceiverRequest).forEach((key) =>  receiverPayload.append(key, showReceiverRequest[key]))
    const response = await axios.post(path, receiverPayload)
    return response
  },
  /**
   * Send/blast announcements to user/customer/seller
   * Invoke `POST  admins/announcements/templates/:id/blast
   * @param {object} payload - Form data for blasting message with csv on it
   */
  blast: async ( { blastRequest } ) => {
    const path                = `${API_PATH}/${blastRequest.id}/blast`
    const blastRequestPayload = new FormData()
    Object.keys(blastRequest).forEach((key) =>  blastRequestPayload.append(key, blastRequest[key]))
    const response = await axios.post(path, blastRequestPayload)
    return response
  },
  /**
   * Send test announcements to one number
   * Invoke `POST admins/announcements/templates/:id/blast_check
   * @param {object} payload - Form data for test blast message with csv on it
   */
  check: async ( { checkRequest } ) => {
    const path                = `${API_PATH}/${checkRequest.id}/blast_check`
    const checkRequestPayload = new FormData()
    Object.keys(checkRequest).forEach((key) =>  checkRequestPayload.append(key, checkRequest[key]))
    const response = await axios.post(path, checkRequestPayload)
    return response
  },
  /**
   * Schedule announcements to a schedule data
   * Invoke `POST admins/announcements/templates/:id/schedule
   * @param {object} payload - Form data for test blast message with csv on it
   */
  schedule: async ( { scheduleRequest } ) => {
    const path                   = `${API_PATH}/${scheduleRequest.id}/schedule`
    const scheduleRequestPayload = new FormData()
    Object.keys(scheduleRequest).forEach((key) => scheduleRequestPayload.append(key, scheduleRequest[key])
    )
    const response = await axios.post(path, scheduleRequestPayload)
    return response
  },
  /**
   * Cancel scheduled announcements
   * Invoke `POST admins/announcements/templates/:id/cancel_scheduled
   * @param {object} payload - Form data for test blast message with csv on it
   */
  cancel_scheduled: async ({ scheduleRequest }) => {
    const path = `${API_PATH}/${scheduleRequest.id}/cancel_scheduled`

    const response = await axios.post(path, scheduleRequest)
    return response
  }
}

export default NotificationTemplatesApi
